import React, { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import ResetPassword from './features/user/ResetPassword';
import SubscriptionPlans from './features/subscriptions/SubscriptionPlans';
import Courses from './features/courses/Courses';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const Register = lazy(() => import('./pages/Register'))
const Documentation = lazy(() => import('./pages/Documentation'))


// Initializing different libraries
initializeApp()


// Check for login and initialize axios
const token = checkAuth()


function App() {

  useEffect(() => {
    // Force default theme to light permanently
    document.documentElement.setAttribute("data-theme", "light")
    localStorage.setItem("theme", "light")

    // Prevent number input value change on wheel scroll
    const handleWheelPrevent = (e) => {
      // Check if the event target is a focused number input
      if (e.target && e.target.type === 'number' && document.activeElement === e.target) {
        // Prevent the default behavior (value change on scroll)
        e.preventDefault()
        // Blur the input to remove focus
        e.target.blur()
      }
    }

    // Add event listener for wheel events
    document.addEventListener('wheel', handleWheelPrevent, { passive: false })

    // Cleanup
    return () => {
      document.removeEventListener('wheel', handleWheelPrevent)
    }
  }, [])


  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/subscription-plans" element={<SubscriptionPlans />} />
          <Route path="/courses" element={<Courses />} />
          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route path="*" element={<Navigate to={token ? "/app/dashboard" : "/login"} replace />}/>

        </Routes>
      </Router>
    </>
  )
}

export default App
